import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Gäller godkänt kunskapsprov i alla kommuner?";
const SHORT_ANSWER = "Ja. Ett godkänt prov hos en kommun gäller även vid ansökan i annan kommun, så länge tillståndstypen är densamma.";

export const Route = createFileRoute("/fraga/galler-provet-i-alla-kommuner")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Gäller godkänt kunskapsprov i alla kommuner" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Folkhälsomyndigheten driver det digitala provsystemet centralt. Resultatet registreras och kan användas i annan kommun – men du måste själv visa godkännandet vid ny ansökan."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – nationellt giltigt" }}
      related={[{"to": "/fraga/hur-lange-galler-godkant-prov", "label": "Hur länge gäller ett godkänt kunskapsprov?"}, {"to": "/fraga/behover-jag-gora-om-provet-vid-utokning", "label": "Behöver jag göra om provet om jag utökar tillståndet?"}, {"to": "/fraga/vad-ar-skillnad-stadigvarande-prov-tillfalligt", "label": "Vad är skillnaden mellan provet för stadigvarande och tillfälligt tillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Gäller godkänt kunskapsprov i alla kommuner?" },
      { name: "description", content: "Ja. Ett godkänt prov hos en kommun gäller även vid ansökan i annan kommun, så länge tillståndstypen är densamma." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/galler-provet-i-alla-kommuner" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/galler-provet-i-alla-kommuner" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/galler-provet-i-alla-kommuner",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Gäller godkänt kunskapsprov i alla kommuner", url: "https://alkoholprovet.se/fraga/galler-provet-i-alla-kommuner" },
      ]),
    ],
  }),
});
